import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {MainComponent} from '../components/landing/main/main.component';
import {FadPersonalComponent} from '../components/landing/fad-personal/fad-personal.component';
import {FadEmpresaComponent} from '../components/landing/fad-empresa/fad-empresa.component';
import {SoporteComponent} from '../components/landing/soporte/soporte.component';
import {FaqsComponent} from '../components/landing/faqs/faqs.component';
import {LoginComponent} from '../components/application/login/login.component';
import {CreateUserComponent} from '../components/landing/create-user/create-user.component';
import {PrivacyNoticeComponent} from '../components/landing/privacy-notice/privacy-notice.component';
import {CumplimientoJuridicoComponent} from '../components/landing/cumplimiento-juridico/cumplimiento-juridico.component';
import {PaymentComponent} from '../components/application/payment/payment.component';
import {PurchaseSummaryComponent} from '../components/application/payment/purchase-summary/purchase-summary.component';
import {ThanksPageComponent} from '../components/landing/thanks-page/thanks-page.component';
import {DescargaCumplimientoComponent} from '../components/landing/descarga-cumplimiento/descarga-cumplimiento.component';
import {TermsConditionsComponent} from '../components/landing/terms-conditions/terms-conditions.component';
import {SecurityInformationComponent} from '../components/landing/security-information/security-information.component';


const routes: Routes = [
    {
        path: '', component: MainComponent,
        data: {
            TITLE: 'Firma digitalmente con validez legal | La única Firma Autógrafa Digital®',
            KEYWORDS: 'firma digital, realizar firma digital online',
            DESCRIPTION: 'FAD® es la única firma digital con patente internacional, equivalente funcional a la firma en papel. Disponible para iOS y Android. ¡Pruébala gratis!',
            URL: 'https://fad.firmaautografa.com/',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/home.png'
        }
    },
    {
        path: 'firma-digital-para-personas', component: FadPersonalComponent,
        data: {
            TITLE: 'Compra un plan de firma digital personal | La única Firma Autógrafa Digital®',
            KEYWORDS: 'firma digital de documentos, como realizar la firma digital de documentos',
            DESCRIPTION: 'Paquetes y suscripciones desde $199 pesos de firma digital, único proceso patentado con 100% de validez legal, probada en juicios, fácil y sencilla de usar.',
            URL: 'https://fad.firmaautografa.com/firma-digital-para-personas',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/personal.png'
        }
    },
    {
        path: 'firma-digital-para-empresas', component: FadEmpresaComponent,
        data: {
            TITLE: 'Compra un plan de firma digital para tu empresa | La única Firma Autógrafa Digital®',
            KEYWORDS: 'firma digital de contratos, realizar firma digital de contratos',
            DESCRIPTION: 'Paquetes y suscripciones desde $499 pesos de firma digital para tu empresa, único proceso patentado con 100% de validez legal, probada en juicios. Integración con cualquier plataforma y sistema.',
            URL: 'https://fad.firmaautografa.com/firma-digital-para-empresas',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/empresas.png'
        }
    },
    {
        path: 'como-empezar-a-firmar-digitalmente', component: SoporteComponent,
        data: {
            TITLE: 'Necesitas ayuda para empezar a firmar con FAD® | La única Firma Autógrafa Digital®',
            KEYWORDS: 'como conseguir una firma digital, como obtener firma digital',
            DESCRIPTION: 'Consulta con cualquiera de nuestros ejecutivos el paquete o suscripción que más se acomode a tus necesidades, contáctanos al +52 (55) 2665 9500',
            URL: 'https://fad.firmaautografa.com/como-empezar-a-firmar-digitalmente',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/soporte.png'
        }
    },
    {
        path: 'preguntas-frecuentes-de-la-firma-digital-fad', component: FaqsComponent,
        data: {
            TITLE: 'Preguntas frecuentes sobre la firma digital FAD® | La única Firma Autógrafa Digital®',
            KEYWORDS: 'como firmar un documento digitalmente, como firmar un documento en pdf',
            DESCRIPTION: 'Conoce cómo firmar un documento con Firma Autógrafa Digital. Solicita tu prueba gratis y empieza a firmar con FAD®',
            URL: 'https://fad.firmaautografa.com/preguntas-frecuentes-de-la-firma-digital-fad',
            IMG: ''
        }
    },
    {
        path: 'inicia-sesion', component: LoginComponent,
        data: {
            TITLE: 'Inicia sesión en FAD® y empieza a firmar digitalmente | La única Firma Autógrafa Digital®',
            KEYWORDS: 'empieza a firma digitalmente',
            DESCRIPTION: 'Crea una cuenta o inicia sesión en FAD®. Firma cualquier contrato de manera remota con total validez legal. Conoce nuestros paquetes y planes de suscripción.',
            URL: 'https://fad.firmaautografa.com/inicia-sesion',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/sesion.png'
        }
    },
    {
        path: 'firma-digital-gratis', component: CreateUserComponent,
        data: {
            TITLE: 'Prueba gratis nuestra firma digital | La única Firma Autógrafa Digital®',
            KEYWORDS: 'firma digital gratis, crear firma digital gratis',
            DESCRIPTION: 'Obtén una firma digital gratis y empieza a probar FAD®. Descarga la aplicación para dispositivos móviles y firma desde cualquier parte del mundo.',
            URL: 'https://fad.firmaautografa.com/firma-digital-gratis',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/prueba.jpg'
        }
    },
    {
        path: 'aviso-de-privacidad', component: PrivacyNoticeComponent,
        data: {
            TITLE: 'Aviso de privacidad | La única Firma Autógrafa Digital®',
            KEYWORD: 'aviso de privacidad de fad',
            DESCRIPTION: 'El cuidado de tus datos es importante para nosotros, conoce nuestro aviso de privacidad. Cualquier duda o queja contáctanos al correo privacidad@na-at.com.mx',
            URL: 'https://fad.firmaautografa.com/aviso-de-privacidad',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/privacidad.png'
        }
    },
    {
        path: 'cumplimiento-juridico-de-la-firma-digital', component: CumplimientoJuridicoComponent,
        data: {
            TITLE: 'Conoce la validez legal de FAD® | La única Firma Autógrafa Digital®',
            KEYWORDS: 'validez de la firma digital, firma digital legal',
            DESCRIPTION: 'La Firma Autógrafa Digital tiene completa validez legal de acuerdo a diferentes ordenamientos, 2000s US ESIGN, 1997 UETA, TMEC, UNCITRAL, entre otros.',
            URL: 'https://fad.firmaautografa.com/cumplimiento-juridico-de-la-firma-digital',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/validez.png'
        }
    },
    {
        path: 'cumplimiento-juridico-de-la-firma-digital/descarga-el-tuyo', component: DescargaCumplimientoComponent,
        data: {
            TITLE: 'Conoce la validez legal de FAD® | La única Firma Autógrafa Digital®',
            KEYWORDS: '',
            DESCRIPTION: 'La Firma Autógrafa Digital tiene completa validez legal de acuerdo a diferentes ordenamientos, 2000s US ESIGN, 1997 UETA, TMEC, UNCITRAL, entre otros.',
            URL: 'https://fad.firmaautografa.com/cumplimiento-juridico-de-la-firma-digital/descarga-el-tuyo',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/validez.png'
        }
    },
    {
        path: 'comprar-firma-digital', component: PaymentComponent,
        data: {
            TITLE: 'Adquiere un paquete de firma digital | La única Firma Autógrafa Digital®',
            KEYWORDS: 'comprar firma digital',
            DESCRIPTION: 'Realiza la compra de paquete o suscripción de Firma Autógrafa Digital®. Inicia sesión y comienza a firmar tus documentos de inmediato.',
            URL: 'https://fad.firmaautografa.com/comprar-firma-digital',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/home.png'
        }
    },
    {
        path: 'exito-compra-firma-digital', component: PurchaseSummaryComponent,
        data: {
            data: {
                TITLE: 'Gracias por adquirir un paquete de firma digital | La única Firma Autógrafa Digital®',
                KEYWORDS: 'gracias por comprar firma digital',
                DESCRIPTION: 'Gracias por la compra de un paquete o suscripción de Firma Autógrafa Digital®. Inicia sesión y comienza a firmar tus documentos de inmediato.',
                URL: 'https://fad.firmaautografa.com/comprar-firma-digital',
                IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/sesion.png'
            }
        }
    },
    {
        path: 'gracias-por-contactarnos', component: ThanksPageComponent,
        data: {
            TITLE: 'Firma digitalmente con validez legal | La única Firma Autógrafa Digital®',
            KEYWORDS: 'firma digital, realizar firma digital online',
            DESCRIPTION: 'FAD® es la única firma digital con patente internacional, equivalente funcional a la firma en papel. Disponible para iOS y Android. ¡Pruébala gratis!',
            URL: '',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/home.png'
        }
    },
    {
        path: 'terminos-y-condiciones', component: TermsConditionsComponent,
        data: {
            TITLE: 'Términos y condiciones | La única Firma Autógrafa Digital®',
            KEYWORDS: 'terminos y condiciones de fad',
            DESCRIPTION: 'El cuidado de tus datos es importante para nosotros, conoce nuestro aviso de privacidad. Cualquier duda o queja contáctanos al correo privacidad@na-at.com.mx',
            URL: 'https://fad.firmaautografa.com/aviso-de-privacidad',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/terminos.jpg'
        }
    },
    {
        path: 'politica-de-seguridad', component: SecurityInformationComponent,
        data: {
            TITLE: 'Politica de Seguridad de la Informacion | La única Firma Autógrafa Digital®',
            KEYWORDS: 'politica de seguridad de la informacion de fad',
            DESCRIPTION: 'El cuidado de tus datos es importante para nosotros. Cualquier duda o queja contáctanos al correo privacidad@na-at.com.mx',
            URL: 'https://fad.firmaautografa.com/politica-de-seguridad',
            IMG: 'https://hola.firmaautografa.com/hubfs/FM-ASSETS/METAS-PLACE-BA-PAGES/home.png'
        }
    },
    {path: '**', pathMatch: 'full', redirectTo: ''}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class RoutingModule {
}
